import styled from "styled-components";

export const VerticalBar = styled.div`
  width: 0;
  border-left: 1px solid ${({ theme }) => theme.colors.borderPrimary};
  align-self: flex-end;
  height: ${({ theme }) => theme.spacing(6)};
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
`;
